import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';

function MarketProductBox({ marketProduct, onEditClick, onDeleteClick }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box m="10px" mb="20px" p="20px"
            width={"30%"}
            display="inline-block"
            sx={{
                background: (theme.palette.mode === "dark" ? colors.primary[500] : "white"), border: "1px solid " + colors.grey[500],
                borderRadius: "20px"
            }}
        >
            <Box display="flex" justifyContent="space-between">
                <Box display="flex" alignItems="center" >
                    <Box>
                        <img
                            alt="product"
                            src={marketProduct.image_link}
                            width="40px"
                            height="40px"
                            style={{ cursor: "pointer", borderRadius: "20%" }} />
                    </Box>
                    <Box ml="10px">
                        <Box display="flex" gap="5px">
                            <Typography variant='h4'>{marketProduct.name}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black") }} />

            <Box>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Açıklama:</b> <br />{marketProduct.description || "-"}</Typography>

                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Fiyat:</b> <br />{marketProduct.app_price || "-"} APP</Typography>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Stok:</b> <br />{marketProduct.active_coupon_count + marketProduct.taken_coupon_count}</Typography>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Alınan Kupon Sayısı:</b> <br />{marketProduct.taken_coupon_count}</Typography>

                {marketProduct.link.length >= 30 &&
                    <Tooltip title={marketProduct.link}>
                        <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={marketProduct.link} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{marketProduct.link.slice(0, 30) + "..."}</a></Typography>
                    </Tooltip>
                }

                {marketProduct.link.length < 30 &&
                    <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={marketProduct.link} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{marketProduct.link}</a></Typography>
                }

                <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black"), marginTop: "20px" }} />
            </Box>

            <Box display={"flex"} justifyContent={"space-evenly"} mt="10px">
                <Button variant='contained' sx={{ background: colors.blueAccent[500] }} onClick={() => onEditClick(marketProduct)}>Düzenle</Button>
                <Button variant='contained' color="error" onClick={() => onDeleteClick(marketProduct)}>Sil</Button>
            </Box>
        </Box >
    )
}

export default MarketProductBox